// eslint-disable-next-line @typescript-eslint/no-empty-function
export function noop(): void {}

export const makeTestId = (testId: string, suffix: string): string | null => {
    if (!testId || typeof testId != 'string') {
        return null;
    }

    return `${testId}-${suffix}`;
};

export const lipsumLong =
    'Lorem, ipsum dolor sit amet consectetur adipisicing elit. Cupiditate tenetur maxime necessitatibus eligendi error laboriosam fugiat consequatur ab laudantium fuga a natus quos ea, et minus harum illo aperiam in ratione vitae? Vitae quas error odit, amet mollitia blanditiis ex quasi, ducimus ipsa rem quibusdam adipisci, incidunt neque sapiente nam!';
export const lipsumSmall = 'The quick brown fox jumps over the lazy dog.';
